module.exports = __webpack_public_path__ + "static/media/hero-decor.16abb8ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/general/hero-decor.svg
// module id = 319
// module chunks = 0